import CapitalAccountPage from '../pages/capital-account-page.vue'

export default [
  {
    component: CapitalAccountPage,
    name: 'transacting.capital-account',
    path: '/:slug/transacting/:transacting_type/:transacting_id/capital-account',
  },
]
